import { PropTypes } from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { HandleClickOutside } from '../../common/HandleClickOutside'
import { Dropdown, positionDropdown } from '../../common/dropdown'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { ScrollComponent } from '../../common/scrollComponent'

export const InputSearchDropdown = ({
  renderElement,
  renderDropdown,
  isDropdownFollowWidth,
  // onToggleShowDropdown,
  dropdownItemHeight,
  dropdownPosition,
  // isDisplayDropdown,
  data,
  style,
  isLoading,
  renderNodata,
  isValidateTwoKey,
  textInput,
  customContentDropdown,
  exceptRef,
  onDropdownRef,
}) => {
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const elementRef = useRef()
  const dropdownRef = useRef()

  const showDropdown = () => {
    setIsShowDropdown(true)
  }

  const hideDropdown = () => {
    setIsShowDropdown(false)
  }

  // useEffect(() => {
  //   onToggleShowDropdown && onToggleShowDropdown(isShowDropdown)
  // }, [isShowDropdown])

  const dropdownHeight = dropdownItemHeight
    ? data?.length * dropdownItemHeight
    : null

  const position =
    dropdownPosition || dropdownHeight
      ? window.innerHeight -
          elementRef.current?.getBoundingClientRect()?.bottom <
        dropdownHeight
        ? positionDropdown.TOP_LEFT_RIGHT
        : positionDropdown.BOTTOM_LEFT_RIGHT
      : positionDropdown.BOTTOM_LEFT_RIGHT

  useEffect(() => {
    const hideDropdown = () => setIsShowDropdown(false)

    const scrollElement = document.querySelector(
      `#MainContent .scrollbars div:first-child`,
    )

    window.addEventListener('resize', hideDropdown)
    if (scrollElement) {
      scrollElement.addEventListener('scroll', hideDropdown)
    }

    return () => {
      window.removeEventListener('resize', hideDropdown)
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', hideDropdown)
      }
    }
  }, [])

  // useEffect(() => {
  //   if (isDisplayDropdown) {
  //     setIsShowDropdown(true)
  //   }
  // }, [isDisplayDropdown])

  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        setIsShowDropdown(false)
      }
    }
    document.addEventListener('keydown', handleKeydown)

    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [])

  useEffect(() => {
    if (onDropdownRef) {
      onDropdownRef(dropdownRef.current?.getDropdownRef())
    }
  }, [onDropdownRef])

  return (
    <>
      <Element ref={elementRef} onClick={showDropdown} style={{ ...style }}>
        {renderElement({ isShowDropdown, showDropdown, hideDropdown })}
      </Element>

      <Dropdown
        ref={dropdownRef}
        parentRef={elementRef}
        position={positionDropdown.BOTTOM_START_RIGHT}
        zIndex={13}
      >
        <HandleClickOutside
          handleClickOutside={hideDropdown}
          exceptRef={[elementRef, ...(exceptRef ? [].concat(exceptRef) : [])]}
        >
          <Element
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: 4,
              overflow: 'hidden',
              width: isDropdownFollowWidth
                ? elementRef?.current?.offsetWidth
                : undefined,
              minWidth: !isDropdownFollowWidth
                ? elementRef?.current?.offsetWidth
                : undefined,
              maxWidth: !isDropdownFollowWidth ? 600 : undefined,
            }}
          >
            {isShowDropdown && (
              <>
                {isLoading || customContentDropdown() ? (
                  <>
                    {isLoading ? (
                      <div style={{ padding: 20 }}>
                        <Loading />
                      </div>
                    ) : customContentDropdown() ? (
                      customContentDropdown()
                    ) : null}
                  </>
                ) : data?.length ? (
                  <>
                    {textInput.length === 1 && isValidateTwoKey ? (
                      <Element
                        style={{
                          fontStyle: 'italic',
                          padding: 12,
                          color: 'rgb(224, 80, 91)',
                        }}
                      >
                        <Translate value="connectMap.main.LEAST2" />
                      </Element>
                    ) : dropdownHeight ? (
                      <ScrollComponent autoHeight autoHeightMax={400}>
                        {renderDropdown({ hideDropdown, position })}
                      </ScrollComponent>
                    ) : (
                      renderDropdown({ hideDropdown, position })
                    )}
                  </>
                ) : (
                  <>
                    {renderNodata && !data?.length ? (
                      <>
                        {textInput.length === 1 && isValidateTwoKey ? (
                          <Element
                            style={{
                              fontStyle: 'italic',
                              padding: 12,
                              color: 'rgb(224, 80, 91)',
                            }}
                          >
                            <Translate value="connectMap.main.LEAST2" />
                          </Element>
                        ) : (
                          renderNodata()
                        )}
                      </>
                    ) : null}
                  </>
                )}
              </>
            )}
          </Element>
        </HandleClickOutside>
      </Dropdown>
    </>
  )
}

InputSearchDropdown.propTypes = {
  renderElement: PropTypes.func.isRequired,
  renderDropdown: PropTypes.func.isRequired,
  isDropdownFollowWidth: PropTypes.bool,
  // onToggleShowDropdown: PropTypes.func,
  dropdownItemHeight: PropTypes.number,
  dropdownPosition: PropTypes.string,
  // isDisplayDropdown: PropTypes.bool,
  data: PropTypes.any,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
  renderNodata: PropTypes.func,
  isValidateTwoKey: PropTypes.bool,
  textInput: PropTypes.string,
  customContentDropdown: PropTypes.func,
  exceptRef: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

InputSearchDropdown.defaultProps = {
  renderElement: () => null,
  renderDropdown: () => null,
  isDropdownFollowWidth: true,
  positionDropdown: positionDropdown.BOTTOM_LEFT_RIGHT,
  // isDisplayDropdown: false,
  data: [1],
  isLoading: false,
  style: { width: 'fit-content' },
  dropdownStyleNoData: {},
  isValidateTwoKey: false,
  textInput: '',
  customContentDropdown: () => null,
  exceptRef: null,
}
